import type { TPreSignedImageServiceName } from 'interfaces/common';
import type { IStoreImageOrderRequest, TStoreImageType } from 'interfaces/store';

export type TStoreImageModalType = 'THUMBNAIL' | 'SIGNATURE' | 'MENU' | 'NOTICE' | 'MEAL_PLAN';

export const STORE_IMAGE_UPLOAD: Record<
  TStoreImageModalType,
  { type?: TStoreImageType; serviceName: TPreSignedImageServiceName }
> = {
  THUMBNAIL: { serviceName: 'store-thumbnail' },
  SIGNATURE: { type: 'STORE_IMAGE_TYPE_SIGNATURE', serviceName: 'store-signature' },
  MENU: { type: 'STORE_IMAGE_TYPE_MENU_BOARD', serviceName: 'store-menu-board' },
  NOTICE: { type: 'STORE_IMAGE_TYPE_NOTICE', serviceName: 'store-notice' },
  MEAL_PLAN: { type: 'STORE_IMAGE_TYPE_NOTICE_POPUP', serviceName: 'store-notice-popup' }
};

export const buildStoreImageOrderRequest = (
  type: TStoreImageType,
  images: { idx?: number; imageUrl: string }[]
): IStoreImageOrderRequest => ({
  type,
  storeImages: images.map(({ idx, imageUrl }, index) => ({ ...(idx ? { idx } : {}), displayOrder: index + 1, imageUrl }))
});
